import { Box, styled, Typography } from "@mui/material"

export const Header = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
})

export const InfoText = styled(Typography)({
  fontSize: "1.2rem",
  color: "#757575",
  fontWeight: 400,
})

export const StrongText = styled("strong")({
  fontWeight: 500,
  color: "#353535",
})
